module.exports = __webpack_public_path__ + "img/p8s-Logo.b7be64da.svg";